import enumCache from '@/shared/services/EnumCacheService';
import { listItemMsg } from '@/shared/components/FormattedListValue';
import { dynamicSort } from '@/shared/utils/dynamicSort';
import api from '../../../shared/api';
import config from '../../../config';

export const getDocumentTypes = async intl => {
  const documentTypes = await enumCache.get('documenttype');
  const { data: documentTypeSettings } = await api.base.get(
    `${config.appUrls.documents}/api/DocumentTypeSetting`,
  );

  const filteredDocumentTypes = documentTypes
    .filter(x => x.key !== -1 && x.key !== 15 && x.key !== 100000) // Exclude Unknown, Temporary and CertificateOfTraining
    .map(x => ({
      key: x.key,
      label: intl.formatMessage(listItemMsg('documenttype', x.key, x.value)),
    }))
    .sort(dynamicSort('label'));

  const enrichedDocumentTypes = filteredDocumentTypes.map(docType => {
    const settings = documentTypeSettings.find(setting => setting.documentType === docType.key);
    return {
      ...docType,
      setIsPublicOnPortal: settings ? settings.setIsPublicOnPortal : false,
    };
  });

  return enrichedDocumentTypes;
};

export default { getDocumentTypes };
